import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailsComponent {
  offers$ = this.viewOffersService.offers$;
  selected$ = this.productDetailsService.selected$;
  offerReference$ = this.viewOffersService.offerReference$;
  itemOffer$ = this.additionalServicesService.itemOffer$;
  comparisons$ = this.viewOffersService.comparisons$;

  constructor(
    public viewOffersService: ViewOffersService,
    public productDetailsService: ProductDetailsService,
    public additionalServicesService: AdditionalServicesService
  ) {}
}
